import { createListReducer } from '../../../common/services/reducerCreator';

export default createListReducer('PARTNER_OFFER_LIST');
